import { createHourDropdownOptions } from '@acorn-portal/shared/src/utils/create-hour-dropdown-options';
import { createMinuteDropdownOptions } from '@acorn-portal/shared/src/utils/create-minute-dropdown-options';
import { MinuteIncrement } from './types';

export const getStaticTimeOptions = (minuteIncrement: MinuteIncrement) => ({
	hours: createHourDropdownOptions(),
	minutes: createMinuteDropdownOptions(minuteIncrement),
});
